import {
  ApiResult
} from '@/services/data'
import ServiceBase from '@/services/serviceBase'

export interface AccountTrade {
  AccountId: string;
  Time: string;
  TransactionId: string;
  OrderId: string;
  Symbol: string;
  Price: number;
  Qty: number;
  QuoteQty: number;
  CommissionAsset: string;
  Commission: number;
  IsBuyer: boolean;
  IsMaker: boolean;
  IsBestMatch: boolean;
}

export interface AccountBalance {
  AccountId: string;
  Asset: string;
  Free: number;
  Locked: number;
}

export default {
  async getTrades (forceUpdate: boolean): Promise<ApiResult<AccountTrade[]>> {
    const trades = await ServiceBase.tryPostResult<AccountTrade[]>(`/Binance/GetTrades?forceUpdate=${forceUpdate || 'false'}`, {})
    return trades
  },
  async getBalances (forceUpdate: boolean): Promise<ApiResult<AccountBalance[]>> {
    const balences = await ServiceBase.tryPostResult<AccountBalance[]>(`/Binance/GetBalances?forceUpdate=${forceUpdate || 'false'}`, {})
    return balences
  },
  async downloadTrades () {
    return await ServiceBase.tryDownload('/Binance/downloadTrades')
  },
  async downloadBalance () {
    return await ServiceBase.tryDownload('/Binance/downloadBalances')
  }
}
